import request, { requestPaginationData } from './index'

request.post = request.post || (() => null)

export const requestBasefiles = (params) => requestPaginationData('/basefiles', params)
export const requestBasefile = (id) => request(`/basefiles/${id}`)
export const requestCreateBasefile = (data) => request.post('/basefiles', { data })
export const requestUpdateBasefile = (id, data) => request.put(`/basefiles/${id}`, { data })
export const requestDeleteBasefile = (id) => request.delete(`/basefiles/${id}`)
export const requestCountBasefileAssociatedResumes = (id) => request.get(`/basefiles/${id}/associated-resumes-count`)

export const requestResumes = (params) => requestPaginationData('/resumes?populate=basefile', params)
export const requestResume = (id) => request(`/resumes/${id}?populate=basefile,portfolios`)
export const requestResumeMeta = (uuid) => request.get(`/resumes/${uuid}/meta`)
export const requestCountResumes = () => request.get(`/resumes/count`)
export const requestProtectedResume = (uuid, password) => request(`/resumes/${uuid}/view?populate=basefile,portfolios&password=${password}`)
export const requestCreateResume = (data) => request.post('/resumes?populate=basefile,portfolios', { data })
export const requestUpdateResume = (id, data) => request.put(`/resumes/${id}?populate=basefile,portfolios`, { data })
export const requestDeleteResume = (id) => request.delete(`/resumes/${id}`)

export const requestCreateResumeComment = (uuid, data) => request.post(`/resumes/${uuid}/comments`, { data })
export const requestResumeComments = (uuid, params) => requestPaginationData(`/resumes/${uuid}/comments`, params)

export const requestBasefileSlots = () => request('/basefiles/slots')
export const requestPurchaseBasefileSlots = () => request.post('/basefiles/slots').then((res) => res.data)
export const requestResumeSlots = () => request('/resumes/slots')
export const requestPurchaseResumeSlots = () => request.post('/resumes/slots').then((res) => res.data)
export const requestPortfolioSlots = () => request('/portfolios/slots')
export const requestPurchasePortfolioSlots = (count) => request.post(`/portfolios/slots/purchase/${count}`).then((res) => res.data)

export const requestLike = (type, id) => request.post(`/like/${type}/${id}`).then((res) => res.data)
export const requestUnlike = (type, id) => request.post(`/unlike/${type}/${id}`).then((res) => res.data)

export const requestMockupBasefile = () => fetch(`${process.env.NEXT_PUBLIC_ASSETS_PATH || ''}/json/basefile_mock.json`).then((res) => res.json())

export const requestTemplates = (options) => requestPaginationData('/templates', null, options)
export const requestTemplate = (slug, options) => request(`/templates/slug/${slug}`, options)
export const requestTemplateMetas = () => request(`/templates/metas`).then((res) => res.data)
export const requestPurchaseTemplate = (slug) => request.post(`/templates/purchase/${slug}`).then((res) => res.data)

export const requestReceivedComments = (params) => requestPaginationData('/comments/received', { sort: 'id:DESC', ...params })
export const requestCommentsFromMe = (params) => requestPaginationData('/comments/sent', params)

export const requestPortfolios = (params) => requestPaginationData('/portfolios', { sort: 'id:ASC', ...params })
export const requestCreatePortfolio = (data) => request.post('/portfolios', { data })
export const requestUpdatePortfolio = (id, data) => request.put(`/portfolios/${id}`, { data })
export const requestDeletePortfolio = (id) => request.delete(`/portfolios/${id}`)

export const requestArticles = (params, options) => requestPaginationData('/articles', params, options)
export const requestArticle = (id, options) => request(`/articles/${id}`, options)
export const requestCreateArticleComment = (id, data) => request.post(`/articles/${id}/comments`, { data })
export const requestArticleComments = (id, params) => requestPaginationData(`/articles/${id}/comments`, params)

export const requestQuestions = (params) => requestPaginationData('/questions', params)
